import React from "react";
import "../css/provider.version.css";
import { useAgent } from "../../../contexts/AgentsContext";

const VersionAndProvider = ({ activeAgentData }) => {

  return (
    <div>
      <div className="provider-info-container" style={{ marginTop: "32px" }}>
        <div className="row">
          <div className="col-md-12">
            <h3 className="provider-info-title">Version and Provider</h3>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="provider-details">
              <div className="provider-detail-row mb-3">
                <div className="col-md-3">
                  <span className="detail-label">Version</span>
                </div>
                <div className="col-md-9">
                  <span className="detail-value">
                    {activeAgentData?.agent_metadata?.a2a?.version || "N/A"}
                  </span>
                </div>
              </div>
              <div className="provider-detail-row mb-3">
                <div className="col-md-3">
                  <span className="detail-label">Provider</span>
                </div>
                <div className="col-md-9">
                  <span className="detail-value">
                    {activeAgentData?.agent_metadata?.a2a?.provider || "N/A"}
                  </span>
                </div>
              </div>
              <div className="provider-detail-row mb-3">
                <div className="col-md-3">
                  <span className="detail-label">Documentation URL</span>
                </div>
                <div className="col-md-9">
                  <span className="detail-value">
                    {activeAgentData?.agent_metadata?.a2a?.documentationUrl ? (
                      <a
                        href={
                          activeAgentData?.agent_metadata?.a2a?.documentationUrl
                        }
                        target="_blank"
                        rel="noopener noreferrer"
                        className="documentation-link"
                      >
                        {activeAgentData?.agent_metadata?.a2a?.documentationUrl}
                      </a>
                    ) : (
                      <a
                        href={
                          activeAgentData?.agent_metadata?.a2a?.documentationUrl
                        }
                        target="_blank"
                        rel="noopener noreferrer"
                        className="documentation-link"
                      >
                        {activeAgentData?.agent_metadata?.a2a?.documentationUrl}
                      </a>
                    )}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VersionAndProvider;
